/** Runtime half of the guide-only static-to-React handoff. No route-wide change. */
export function guideShellFor(path) {
  const shell = document.getElementById('seo-prerender');
  return shell?.dataset.guidePath === path ? shell : null;
}

export function removeCrawlerShell() {
  const shell = document.getElementById('seo-prerender');
  // GuidePage owns this shell until its lazy content has committed.
  if (!shell?.dataset.guidePath) shell?.remove();
}

export function mountGuideShell(shell, main) {
  if (!shell?.isConnected || !main) return;
  const staticMain = shell.querySelector('.guide-page main');
  const root = document.getElementById('root');
  if (!staticMain || !root?.hasAttribute('data-guide-pending')) return;
  const focused = document.activeElement;
  const inContent = staticMain.contains(focused);
  const href = shell.contains(focused) ? focused.getAttribute('href') : null;

  // Preserve the painted LCP nodes, IDs, native disclosure state and links.
  // React owns this opaque HTML boundary; its stable __html stays empty.
  main.replaceChildren(...staticMain.childNodes);
  shell.remove();
  root.removeAttribute('hidden');
  root.removeAttribute('inert');
  root.removeAttribute('aria-hidden');
  root.removeAttribute('data-guide-pending');
  if (inContent) focused.focus({ preventScroll: true });
  else if (href) {
    const replacement = [...root.querySelectorAll('a[href]')].find(a => a.getAttribute('href') === href);
    replacement?.focus({ preventScroll: true });
  }
}
